
<router-outlet></router-outlet>
<app-download-panel></app-download-panel>
